export type Validator = (nextValue: unknown, prevValue: unknown) => ValidationResult

export enum ValidationState {
    Error,
    Warning,
    OK
}

export interface ValidationResult {
    error: ValidationState
    message: string
    sanitizedValue: unknown
    customValidationResult?: unknown
}
